import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./header.module.scss";
import { connect } from "react-redux";
import {
  setActiveFeature,
  setActiveProject,
  setActiveFilter,
  setAllFilters,
  setActivePage,
  setMapType,
  setBasemap,
  setZoomToNsw,
  setSearchBarVisible,
} from "../../actions/ui";
import {
  selectHoveredFeature,
  selectActiveFilters,
  selectActivePage,
  selectActiveFeature,
  selectAllCategories,
  selectViewingHub,
  selectIsInternal,
  selectMapType,
  selectBasemap,
  selectSearchBarVisible,
} from "../../reducers/";
import Search from "../search";
import NSWSvg from "./nsw-svg";
import { getIcon } from "../../modules/category";
import geojsonConfig from "../../modules/geometryConfigs";
import { ChevronIconDown, ChevronIconUp } from "../icons";
import { colors } from "../../modules/theme";

import { SIDEBAR_WIDTH } from "../../modules/theme";

class Header extends Component {
  constructor(props) {
    super();
    this.state = {
      filterBoxOpen: false,
      mapTypeBoxOpen: false,
    };
    this.handleToggleFilterClick = this.handleToggleFilterClick.bind(this);
  }
  handleToggleFilterClick(hub) {
    return e => {
      return this.props.setActiveFilter(hub);
    };
  }
  isActiveFilter(category) {
    const { activeFilters } = this.props;

    if (activeFilters.includes(category)) {
      // If filters are clicked but this is enabled, light up
      return true;
    }
    // We are filtering and this one isn't active
    return false;
  }

  // Explore all / Explore multiple / Explore food etc.
  renderFilterHeader() {
    return (
      <span>
        <span>Explore</span>
        <span> </span>
        {this.props.activeFilters.length === this.props.categories.length && (
          <span className={styles.filterDescription}>All</span>
        )}
        {this.props.activeFilters.length > 1 &&
          this.props.activeFilters.length < this.props.categories.length && (
            <span className={styles.filterDescription}>Multiple</span>
          )}
        {this.props.activeFilters.length === 1 && (
          <span className={styles.filterDescription}>
            {this.props.activeFilters[0]}
          </span>
        )}
      </span>
    );
  }

  renderFilter() {
    const { viewingHub } = this.props;
    if (viewingHub) return null;
    if (this.state.filterBoxOpen === false) {
      return (
        <button
          className={`${styles.headerButton} ${styles.filterButton}`}
          onClick={() => this.setState({ filterBoxOpen: true })}
        >
          {this.renderFilterHeader()}
          <ChevronIconDown width="20px" height="20px" />
        </button>
      );
    }

    const filterItems = this.props.categories.map(category => {
      const isActive = this.isActiveFilter(category);
      return (
        <div key={category} className={styles.filterItem}>
          <button
            data-active={isActive}
            className={styles.filterItemButton}
            onClick={this.handleToggleFilterClick(category)}
          >
            <img
              src={getIcon(category, isActive)}
              alt={category}
              className={styles.categoryIcon}
            />
            <label>{category}</label>
          </button>
        </div>
      );
    });

    return (
      <div className={styles.filters}>
        <div className={styles.filtersHeader}>
          {this.renderFilterHeader()}
          <button
            onClick={() => this.setState({ filterBoxOpen: false })}
            className={styles.filterCloseButton}
          >
            <ChevronIconUp width="20px" height="20px" />
          </button>
        </div>

        <button
          style={{
            border: `1px solid ${
              this.props.activeFilters.length < 9
                ? colors.darkBlue
                : "rgb(204,211,219)"
              }`,
            height: 30,
            width: "100%",
            color: "white",
            backgroundColor:
              this.props.activeFilters.length < 9
                ? colors.darkBlue
                : "rgb(204,211,219)",
            cursor: "pointer",
            marginBottom: 10,
          }}
          onClick={() => {
            this.props.setAllFilters();
          }}
        >
          Select all
        </button>

        {filterItems}
      </div>
    );
  }

  renderDataSet() {
    const dataSetItems = ["cases", "occupations"].map(dataSet => {
      return (
        <div key={dataSet} className={styles.filterItem}>
          <button
            onClick={() => {
              alert(
                `changed to ${dataSet}`)
            }}
            // onClick={() => this.props.setMapType(dataSet)}
            // data-active={this.props.mapType === dataSet}
            // disabled={this.props.mapType === dataSet}
            className={styles.mapTypeButton}
          >
            {dataSet}
          </button>
        </div>
      );
    });
    return (
      <div className={styles.filters}>
        <div className={styles.filtersHeader}>
          <span>Dataset</span>
          <button
            onClick={() => this.setState({ mapTypeBoxOpen: false })}
            className={styles.filterCloseButton}
          >
            &times;
          </button>
        </div>
        {dataSetItems}
      </div>
    );

  }

  renderMapType() {
    if (!this.props.isInternal) return;

    if (this.state.mapTypeBoxOpen === false) {
      return (
        <button
          className={`${styles.headerButton} ${styles.filterButton}`}
          onClick={() => this.setState({ mapTypeBoxOpen: true })}
          style={{ zIndex: 1000 }}
        >
          <span>Map Type</span>
        </button>
      );
    }
    const mapTypeItems = Object.keys(geojsonConfig).map(mapType => {
      const name = geojsonConfig[mapType].displayName;
      return (
        <div key={mapType} className={styles.filterItem}>
          <button
            onClick={() => this.props.setMapType(mapType)}
            data-active={this.props.mapType === mapType}
            disabled={this.props.mapType === mapType}
            className={styles.mapTypeButton}
          >
            {name}
          </button>
        </div>
      );
    });
    return (
      <div className={styles.filters}>
        <div className={styles.filtersHeader}>
          <span>Map Type</span>
          <button
            onClick={() => this.setState({ mapTypeBoxOpen: false })}
            className={styles.filterCloseButton}
          >
            &times;
          </button>
        </div>
        {mapTypeItems}
      </div>
    );
  }

  renderActiveFeatureName() {
    if (this.props.activeFeature || this.props.hoveredFeature) {
      // Hovered feature takes precedence
      const featureToDisplayInLabel =
        this.props.hoveredFeature || this.props.activeFeature;
      return (
        <p
          className={`${styles.activeFeatureName}`}
          style={{
            border: `1px solid #888`,
            color: `black`,
          }}
        >
          {this.props.nameSelector(featureToDisplayInLabel)}
        </p>
      );
    }
    if (this.props.activePage === "map") return null;
    return "NSW";
  }

  renderContent() {
    return (
      <div className={styles.header} style={{ width: `100%` }}>
        <div className={styles.left}>
          <button
            className={`${styles.searchButton}`}
            style={{ backgroundColor: `rgb(137, 28, 85)` }}
            onClick={() => this.props.setSearchBarVisible(true)}
          >
            <img src={`/img/search-icon-white.svg`} alt="search icon" />
          </button>
          {this.renderActiveFeatureName()}
        </div>
        <div className={styles.right}>
          <button
            className={`${styles.headerButton} ${styles.nswButton}`}
            onClick={() => {
              this.props.setActiveFeature(null);
              this.props.setActiveProject(null);
              this.props.setZoomToNsw(Date.now());
            }}
          >
            <NSWSvg />
          </button>
          {/* {this.renderDataSet()} */}
          {/* {this.renderMapType()} */}
          {/* {this.renderFilter()} */}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div style={{ position: "absolute", width: "100%" }}>
        {this.props.searchBarVisible ? (
          <div
            className={styles.searchContainer}
            style={{
              marginLeft: 20,
              marginRight: SIDEBAR_WIDTH + 20,
              paddingTop: "20px",
            }}
          >
            <div className={styles.search}>
              <Search geometryConfig={this.props.geometryConfig} />
            </div>
          </div>
        ) : (
            <div>{this.renderContent()}</div>
          )}
      </div>
    );
  }
}

Header.propTypes = {
  nameSelector: PropTypes.func.isRequired,
  setSearchBarVisible: PropTypes.func.isRequired,
  setActiveFilter: PropTypes.func.isRequired,
  setAllFilters: PropTypes.func.isRequired,
  setActiveFeature: PropTypes.func.isRequired,
  setActiveProject: PropTypes.func.isRequired,
  activePage: PropTypes.string.isRequired,
  activeFilters: PropTypes.arrayOf(PropTypes.string),
  activeFeature: PropTypes.object,
  hoveredFeature: PropTypes.object,
  categories: PropTypes.arrayOf(PropTypes.string),
  viewingHub: PropTypes.string,
  isInternal: PropTypes.bool.isRequired,
  searchBarVisible: PropTypes.bool.isRequired,
  mapType: PropTypes.string.isRequired,
  setMapType: PropTypes.func.isRequired,
  geometryConfig: PropTypes.object.isRequired,
  setZoomToNsw: PropTypes.func.isRequired,
};

const mapStateToProps = s => ({
  activeFilters: selectActiveFilters(s),
  activePage: selectActivePage(s),
  activeFeature: selectActiveFeature(s),
  hoveredFeature: selectHoveredFeature(s),
  categories: selectAllCategories(s),
  viewingHub: selectViewingHub(s),
  isInternal: selectIsInternal(s),
  mapType: selectMapType(s),
  basemap: selectBasemap(s),
  searchBarVisible: selectSearchBarVisible(s),
});
const mapDispatchToProps = {
  setActiveFeature,
  setActiveFilter,
  setActivePage,
  setMapType,
  setBasemap,
  setZoomToNsw,
  setSearchBarVisible,
  setActiveProject,
  setAllFilters,
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/header/header.js